exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-wrapper[data-v-473b74a8] {\n  display: block;\n  overflow: hidden;\n}\n.field-wrapper label[data-v-473b74a8] {\n  display: block;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.field-wrapper #form-title[data-v-473b74a8] {\n  margin-top: 0;\n  font-weight: 400;\n  text-align: center;\n  color: #88ad3f;\n  margin-bottom: 20px;\n}\n.error[data-v-473b74a8] {\n  color: red;\n}", ""]);

// exports
